import { DataGridPro, DataGridProProps, GridValidRowModel } from '@mui/x-data-grid-pro'
import React, { memo } from 'react'
import tw from 'twin.macro'
import { DropdownMinor } from '@shopify/polaris-icons'
import { GridTableFooter } from 'src/components/shared/grid/GridTableFooter'

interface Props<R extends GridValidRowModel = any> extends DataGridProProps<R> {
  isLoading?: boolean
  EmptyElement?: React.JSXElementConstructor<any>
  className?: any
}

const GridTableComponent = <R extends GridValidRowModel = any>({
  rows,
  columns,
  isLoading,
  paginationModel,
  pageSizeOptions,
  className,
  EmptyElement = () => null,
  ...props
}: Props<R>) => {
  return (
    <div
      css={[
        tw`w-full h-[400px]`,
        {
          '@media (min-height: 830px)': tw`h-[520px]`,
          '@media (min-height: 1000px)': tw`h-[700px]`,
          '@media (min-height: 1440px)': tw`h-[1100px]`,
          '@media (min-height: 2000px)': tw`h-[1500px]`,
        },
        className,
      ]}
    >
      <DataGridPro
        rows={rows}
        columns={columns}
        loading={isLoading}
        pagination={!!paginationModel}
        paginationMode={!!paginationModel ? 'server' : undefined}
        rowHeight={44}
        columnHeaderHeight={36}
        sortingMode="server"
        disableRowSelectionOnClick
        disableColumnFilter
        disableColumnMenu
        disableColumnReorder
        disableColumnSelector
        {...props}
        slots={{
          noRowsOverlay: EmptyElement,
          noResultsOverlay: EmptyElement,
          columnSortedDescendingIcon: () => <DropdownMinor fill="#655E7C" width={20} />,
          columnSortedAscendingIcon: () => (
            <DropdownMinor fill="#655E7C" css={tw`rotate-180`} width={20} />
          ),
          columnUnsortedIcon: () => null,
          footer: () => <GridTableFooter pageSizeOptions={pageSizeOptions} />,
        }}
        css={tw`bg-white border-0`}
      />
    </div>
  )
}

export const GridTable = memo(GridTableComponent) as typeof GridTableComponent
